import { render, staticRenderFns } from "./StationDetails.vue?vue&type=template&id=3716da19&scoped=true"
import script from "./StationDetails.js?vue&type=script&lang=js&external"
export * from "./StationDetails.js?vue&type=script&lang=js&external"
import style0 from "./StationDetails.scss?vue&type=style&index=0&id=3716da19&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716da19",
  null
  
)

export default component.exports